import validate from "/home/docker/node_modules/nuxt/dist/pages/runtime/validate.js";
import access_45global from "/home/docker/middleware/access.global.ts";
import direct_45entry_45global from "/home/docker/middleware/direct-entry.global.ts";
import location_45check_45global from "/home/docker/middleware/location.check.global.ts";
import page_45restriction_45global from "/home/docker/middleware/page.restriction.global.ts";
import rewards_45fetch_45global from "/home/docker/middleware/rewards.fetch.global.ts";
import sso_45auth_45global from "/home/docker/middleware/sso.auth.global.ts";
import utm_45parameter_45global from "/home/docker/middleware/utm-parameter.global.ts";
import manifest_45route_45rule from "/home/docker/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  access_45global,
  direct_45entry_45global,
  location_45check_45global,
  page_45restriction_45global,
  rewards_45fetch_45global,
  sso_45auth_45global,
  utm_45parameter_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}